import React from 'react';
import * as Styled from './styles';
import GraphSkeleton from '../../../UIelements/Skeleton/GraphSkeleton';
import TableSkeleton from '../../../UIelements/Skeleton/TableSkeleton';

const StatsSkeleton: React.FC = () => (
  <Styled.Card>
    <Styled.HeaderRow>
      <Styled.SectionTitle />
      <Styled.ExpandPlaceholder />
    </Styled.HeaderRow>
    <Styled.Grid>
      <Styled.Panel>
        <Styled.PanelTitle />
        <Styled.DoughnutPlaceholder />
      </Styled.Panel>
      <Styled.Panel>
        <Styled.PanelTitle />
        <GraphSkeleton height='220px' />
      </Styled.Panel>
    </Styled.Grid>
    <Styled.TableTitle />
    <TableSkeleton rows={6} />
  </Styled.Card>
);

export default StatsSkeleton;
